import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export interface UpdateCareAdvisorUserBasicInfo {
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  preferred_name?: string;
  gender?: string;
  gender_identity?: string;
  date_of_birth?: string;
  pronouns?: string;
  languages?: number[];
}

export interface UpdateCareAdvisorUserAddress {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip_code: string;
  country?: string;
}

export interface UpdateCareAdvisorUserPayload {
  basic_info?: UpdateCareAdvisorUserBasicInfo;
  address?: UpdateCareAdvisorUserAddress;
  phone_number?: string;
  client_ids?: number[];
  /** Rides with client_ids, but can be sent alone — omitting client_ids grandfathers the user's existing tag set. */
  client_division_ids?: number[];
  guardian_relationship?: string;
  /** Max 40 characters, enforced by the backend. */
  external_id?: string;
}

export const updateCareAdvisorUser = async (
  user_id: number,
  payload: UpdateCareAdvisorUserPayload,
): Promise<UserProfile> => {
  const { data } = await client.patch<UserProfile>(`/care_advisor/users/${user_id}`, payload);

  return data;
};
